import React from 'react'
import { Segment, Dropdown, Checkbox } from "semantic-ui-react";

const CheckboxDropdown = (props) => {
    const {
        label,
        className='',
        itemList,
        toggleSelection,
    } = props
    
    return (
        <>
            <label
                id={`invoices`}
                htmlFor="floatField"
                className={"label-dropdown name-label es"}

            >{label}</label>
            <Dropdown fluid item simple className={`dropdown-checkbox ${className}`}>
                <Dropdown.Menu className='dropdown-checkbox__menu' style={{ width: '100%' }}>
                    {itemList?.length> 0 && itemList.map((itm, idx) => (
                        <Dropdown.Item key={itm?.id}>
                            <Checkbox
                                className='dropdown-checkbox__menu--item'
                                id={itm?.id}
                                label={itm?.title}
                                checked={itm?.isChecked}
                                onChange={toggleSelection}
                            />
                        </Dropdown.Item>
                    ))}
                    {!itemList?.length && (
                        <Dropdown.Item>
                            EMPTY
                        </Dropdown.Item>
                    )}
                </Dropdown.Menu>
            </Dropdown>
        </>
        // <Checkbox label='CUSTOM LABEL'/>
    )
}

export default CheckboxDropdown